import { ThemeProvider } from "styled-components";
import { useState } from "react";
import { darkTheme, lightTheme } from "./utils/Themes.js";
import Navbar from "./components/Navbar";
import "./App.css";
import { HashRouter as Router } from "react-router-dom"; // ✅ FIXED
import HeroSection from "./components/HeroSection";
import SignatureHero from "./components/SignatureHero";
import BentoHero from "./components/BentoHero";
import Skills from "./components/Skills";
import TechStack from "./components/TechStack";
import Experience from "./components/Experience";
import Workflow from "./components/Workflow";
import PRDLibrary from "./components/PRDLibrary";
import ProjectTiles from "./components/ProjectTiles";
import Education from "./components/Education";
import Contact from "./components/Contact";
import FooterBanner from "./components/FooterBanner";
import Footer from "./components/Footer";
import ProjectDetails from "./components/ProjectDetails";
import styled from "styled-components";
import ShapeGrid from "./components/Backgrounds/ShapeGrid";
import DotField from "./components/Backgrounds/DotField";
import Threads from "./components/Backgrounds/Threads";

const AppContainer = styled.div`
  background: transparent;
  min-height: 100vh;
`;

const Body = styled.div`
  width: 100%;
  overflow-x: hidden;
  position: relative;
  background: transparent;
`;

const Wrapper = styled.div`
  background: linear-gradient(
      38.73deg,
      rgba(204, 0, 187, 0.15) 0%,
      rgba(201, 32, 184, 0) 50%
    ),
    linear-gradient(
      141.27deg,
      rgba(0, 70, 209, 0) 50%,
      rgba(0, 70, 209, 0.15) 100%
    );
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
`;

const SectionContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

function App() {
  const [darkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <AppContainer>
          <Navbar />
          <Body>

            {/* Section 1 */}
            <SectionContainer>
              <ShapeGrid 
                shape="square" 
                squareSize={50} 
                borderColor="rgba(157, 80, 255, 0.2)"
                hoverFillColor="rgba(157, 80, 255, 0.4)"
              />
              <HeroSection />
              <Workflow />
            </SectionContainer>

            {/* Section 2 */}
            <SectionContainer>
              <DotField 
                color="rgba(157, 80, 255, 0.25)"
                dotSize={1.5}
                gap={35}
                speed={0.3}
              />
              <SignatureHero />
            </SectionContainer>

            {/* Section 3 */}
            <SectionContainer>
              <Threads 
                color="rgba(157, 80, 255, 0.15)"
                count={30}
                speed={0.6}
              />
              <Wrapper>
                <Skills />
                <TechStack />
                <Experience />
              </Wrapper>
            </SectionContainer>

            {/* Section 4 */}
            <SectionContainer>
              <DotField 
                color="rgba(157, 80, 255, 0.2)"
                dotSize={1}
                gap={40}
                speed={0.2}
              />
              <BentoHero />
              <PRDLibrary />
            </SectionContainer>

            {/* Section 5 */}
            <SectionContainer>
              <ShapeGrid 
                shape="circle" 
                squareSize={60} 
                borderColor="rgba(157, 80, 255, 0.1)"
                hoverFillColor="rgba(157, 80, 255, 0.2)"
              />
              <ProjectTiles openModal={openModal} setOpenModal={setOpenModal} />
            </SectionContainer>

            <SectionContainer>
              <Wrapper>
                <Education />
                <Contact />
              </Wrapper>
            </SectionContainer>

            <FooterBanner />
            <Footer />

            {openModal.state && (
              <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
            )}

          </Body>
        </AppContainer>
      </Router>
    </ThemeProvider>
  );
}

export default App;